import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { DossierActions } from './dossiers.const';
import { IDocument, IDossier, IInvolvedData, IInvolvedItem, IRelations, IRelationsItem } from './dossiers.models';

import {
  DOSSIERS_DATA_ENDPOINTS,
  DOSSIERS_INVOLVED_CONTEXT,
  DOSSIERS_RELATIONS_CONTEXT
} from '~/dossiers/dossier-detail/dossier-detail.const';
import { ILiveSearchResultItem } from '~/repositories/search/store/search.types';
import { Status } from '~/ui/cardview-grid/cardview-grid.types';
import { DetailHeader } from '~/ui/detail/detail-header/detail-header.types';

export const fetchDossier = createAction(DossierActions.fetchDossier, props<{ id: string; showLoading: boolean }>());
export const fetchDossierSuccess = createAction(DossierActions.fetchDossierSuccess, props<{ data: IDossier }>());
export const fetchDossierFailure = createAction(
  DossierActions.fetchDossierFailure,
  props<{ id: string; error: HttpErrorResponse }>()
);

export const fetchDossierData = createAction(
  DossierActions.fetchDossierData,
  props<{ id: string; dataKey: DOSSIERS_DATA_ENDPOINTS; context?: DOSSIERS_RELATIONS_CONTEXT }>()
);
export const fetchDossierDataSuccess = createAction(
  DossierActions.fetchDossierDataSuccess,
  props<{
    id: string;
    dataKey: DOSSIERS_DATA_ENDPOINTS;
    data: IRelations | IDocument[] | IInvolvedData;
    context?: DOSSIERS_RELATIONS_CONTEXT;
  }>()
);
export const fetchDossierDataFailure = createAction(DossierActions.fetchDossierFailure, props<{ error: any }>());

export const updateDossierHeader = createAction(DossierActions.updateDossierHeader, props<{ data: DetailHeader }>());

export const updateDossierHeaderSuccess = createAction(
  DossierActions.updateDossierHeaderSuccess,
  props<{ data: DetailHeader }>()
);

export const updateDossierHeaderFailure = createAction(
  DossierActions.updateDossierHeaderFailure,
  props<{ error: any }>()
);

export const fetchAvailableStatuses = createAction(DossierActions.fetchAvailableStatuses);
export const fetchAvailableStatusesSuccess = createAction(
  DossierActions.fetchAvailableStatusesSuccess,
  props<{ data: Status[] }>()
);
export const fetchAvailableStatusesFailure = createAction(
  DossierActions.fetchAvailableStatusesFailure,
  props<{ error: any }>()
);

export const addDocument = createAction(
  DossierActions.addDocument,
  props<{ dossierId: string; document: IDocument }>()
);

export const removeDocument = createAction(
  DossierActions.removeDocument,
  props<{ dossierId: string; document: IDocument }>()
);
export const removeDocumentSuccess = createAction(
  DossierActions.removeDocumentSuccess,
  props<{ dossierId: string; documentId: string }>()
);
export const removeDocumentFailure = createAction(DossierActions.removeDocumentFailure, props<{ error: any }>());

export const addRelation = createAction(
  DossierActions.addRelation,
  props<{ dossierId: string; context: DOSSIERS_RELATIONS_CONTEXT; relation: ILiveSearchResultItem }>()
);
export const addRelationSuccess = createAction(
  DossierActions.addRelationSuccess,
  props<{ dossierId: string; context: DOSSIERS_RELATIONS_CONTEXT; relation: IRelationsItem }>()
);
export const addRelationFailure = createAction(DossierActions.addRelationFailure, props<{ error: any }>());

export const removeRelation = createAction(
  DossierActions.removeRelation,
  props<{ dossierId: string; context: DOSSIERS_RELATIONS_CONTEXT; relation: IRelationsItem }>()
);
export const removeRelationSuccess = createAction(
  DossierActions.removeRelationSuccess,
  props<{ dossierId: string; context: DOSSIERS_RELATIONS_CONTEXT; relationId: string }>()
);
export const removeRelationFailure = createAction(DossierActions.removeRelationFailure, props<{ error: any }>());

export const addLink = createAction(DossierActions.addLink, props<{ dossierId: string; link: IRelationsItem }>());
export const addLinkSuccess = createAction(
  DossierActions.addLinkSuccess,
  props<{ dossierId: string; link: IRelationsItem }>()
);
export const addLinkFailure = createAction(DossierActions.addLinkFailure, props<{ error: any }>());

export const removeLink = createAction(DossierActions.removeLink, props<{ dossierId: string; link: IRelationsItem }>());
export const removeLinkSuccess = createAction(
  DossierActions.removeLinkSuccess,
  props<{ dossierId: string; linkId: string }>()
);
export const removeLinkFailure = createAction(DossierActions.removeLinkFailure, props<{ error: any }>());

export const addInvolved = createAction(
  DossierActions.addInvolved,
  props<{ dossierId: string; context: DOSSIERS_INVOLVED_CONTEXT; involved: IInvolvedItem }>()
);
export const addInvolvedSuccess = createAction(
  DossierActions.addInvolvedSuccess,
  props<{ dossierId: string; context: DOSSIERS_INVOLVED_CONTEXT; involved: IInvolvedItem }>()
);
export const addInvolvedFailure = createAction(DossierActions.addInvolvedFailure, props<{ error: any }>());

export const removeInvolved = createAction(
  DossierActions.removeInvolved,
  props<{ dossierId: string; context: DOSSIERS_INVOLVED_CONTEXT; involved: IInvolvedItem }>()
);
export const removeInvolvedSuccess = createAction(
  DossierActions.removeInvolvedSuccess,
  props<{ dossierId: string; context: DOSSIERS_INVOLVED_CONTEXT; involvedId: string }>()
);
export const removeInvolvedFailure = createAction(DossierActions.removeInvolvedFailure, props<{ error: any }>());
